import { render, staticRenderFns } from "./GPTContent.vue?vue&type=template&id=f41dcd04&scoped=true"
import script from "./GPTContent.vue?vue&type=script&lang=js"
export * from "./GPTContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41dcd04",
  null
  
)

export default component.exports